module.exports = __webpack_public_path__ + "img/52.887d339e.jpg";